import { reducer } from '../reducers/useFactsheetsFiltersReducer';
import { useReducer, useCallback } from 'react';
import {
    SET_ERASMUS_CODE_ACTION,
    SET_AUTUMN_TERM_DEADLINE_ACTION,
    SET_SPRING_TERM_DEADLINE_ACTION,
    SET_EXPAND_FILTERS_ACTION,
    SET_SELECTED_FILTERS_LIST_ACTION,
    SET_SORT_BY_ACTION,
    UPDATE_MULTIPLE_VALUES_ACTION
} from '../reducers/useFactsheetsFiltersReducer'

// fallback state
export const defaultState = {
    erasmusCode: "",
    autumnTermDeadline: "",
    springTermDeadline: "",
    selectedFiltersList:[],
    sortBy:"",
    expandFilters: false
}

/**
 * Used to handle filters for IIA queries
 * 
 * @param {Object} initialState the initial state of the filters, fallbacks to a default state with empty string and lists if no initial state is provided
 * @returns Filters state as well as handlers for changing the state
 */
export const useFactsheetsFilters = (initialState = defaultState) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const setErasmusCode = useCallback((data) => {
        dispatch({ type: SET_ERASMUS_CODE_ACTION, payload: { erasmusCode: data } });
    }, []);

    const setAutumnTermDeadline = useCallback((data) => {
        dispatch({ type: SET_AUTUMN_TERM_DEADLINE_ACTION, payload: { autumnTermDeadline: data } });
    }, []);

    const setSpringTermDeadline = useCallback((data) => {
        dispatch({ type: SET_SPRING_TERM_DEADLINE_ACTION, payload: { springTermDeadline: data } });
    }, []);

    const setExpandFilters = useCallback((data) => {
        dispatch({ type: SET_EXPAND_FILTERS_ACTION, payload: { expandFilters: data } });
    }, []);

    const setSelectedFiltersList = useCallback((data) => {
        dispatch({ type: SET_SELECTED_FILTERS_LIST_ACTION, payload: { selectedFiltersList: data } });
    }, []);

    const setSortBy = useCallback((data) => {
        dispatch({ type: SET_SORT_BY_ACTION, payload: { sortBy: data } });
    }, []);

    const updateMultipleValues = useCallback((data) => {
        dispatch({ type: UPDATE_MULTIPLE_VALUES_ACTION, payload: data })
    }, []);

    return {
        state,
        setErasmusCode,
        setAutumnTermDeadline,
        setSpringTermDeadline,
        setExpandFilters,
        setSelectedFiltersList,
        setSortBy,
        updateMultipleValues,
    };
}